import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useQuery } from "react-query";
import { PATHS } from "@config/constants";
import { getRemainTurnQuery, getUserQuery } from "@dataLayer/user";
import { isLoggedIn } from "@utils/cookie";

/**
 * Auth helper for MiniGame — aligned with app-wide login (cookie + getUser API).
 * No login popup: unauthenticated actions redirect to the login page.
 */
export function useMiniGameAuth() {
  const history = useHistory();
  const { data: user } = useQuery(getUserQuery());
  const isAuthenticated = isLoggedIn() && !!user;

  const { data: remainTurn = [] } = useQuery({
    ...getRemainTurnQuery(),
    enabled: isAuthenticated,
  });

  const goToLogin = useCallback(() => {
    history.push(PATHS.LOGIN_PAGE);
  }, [history]);

  const requireLogin = useCallback(() => {
    if (!isAuthenticated) {
      history.push(PATHS.LOGIN_PAGE);
      return false;
    }
    return true;
  }, [isAuthenticated, history]);

  return {
    user,
    isAuthenticated,
    remainTurn,
    goToLogin,
    requireLogin,
  };
}
